<div class="container-fluid p-0">
  <div class="col-12 alert alert-warning">
    <span><i class="fas fa-1-5x fa-exclamation-circle m-r-md"></i> {{'Tasks.notImplemented.text'|translate}}</span>
  </div>
</div>
